import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTogglerCollapsed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2021_437)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.5 7H0.5C0.2 7 0 6.8 0 6.5C0 6.2 0.2 6 0.5 6H14.5C14.8 6 15 6.2 15 6.5C15 6.8 14.8 7 14.5 7ZM15 11.5C15 11.2 14.8 11 14.5 11H0.5C0.2 11 0 11.2 0 11.5C0 11.8 0.2 12 0.5 12H14.5C14.8 12 15 11.8 15 11.5ZM18.9 16.9L23.9 11.9C24.1 11.7 24.1 11.4 23.9 11.2L18.9 6.2C18.7 6 18.4 6 18.2 6.2C18 6.4 18 6.7 18.2 6.9L22.8 11.5L18.2 16.1C18 16.3 18 16.6 18.2 16.8C18.3 16.9 18.4 16.9 18.6 16.9C18.8 16.9 18.8 17 18.9 16.9ZM15 16.5C15 16.2 14.8 16 14.5 16H0.5C0.2 16 0 16.2 0 16.5C0 16.8 0.2 17 0.5 17H14.5C14.8 17 15 16.8 15 16.5Z",
			fill: "#F5F4F3"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2021_437",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTogglerCollapsed;
